import { render, staticRenderFns } from "./DashboardAccountPopup.vue?vue&type=template&id=4d0f0b88&scoped=true&"
import script from "./DashboardAccountPopup.vue?vue&type=script&lang=js&"
export * from "./DashboardAccountPopup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAccountPopup.vue?vue&type=style&index=0&id=4d0f0b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f0b88",
  null
  
)

/* custom blocks */
import block0 from "./DashboardAccountPopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports